var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 11.2C12.8 9.432 14.232 8 16 8C17.768 8 19.2 9.432 19.2 11.2C19.2 12.968 17.768 14.4 16 14.4C14.232 14.4 12.8 12.968 12.8 11.2ZM20 24H20.8C21.68 24 22.4 23.28 22.4 22.4V18.576C22.4 17.68 21.912 16.856 21.112 16.448C20.768 16.272 20.392 16.104 20 15.952V24ZM16.272 20L18.4 15.464C17.656 15.296 16.856 15.2 16 15.2C13.976 15.2 12.232 15.76 10.888 16.448C10.088 16.856 9.60004 17.68 9.60004 18.576V24H11.472C11.296 23.64 11.2 23.232 11.2 22.8C11.2 21.256 12.456 20 14 20H16.272ZM14.4 24L15.528 21.6H14C13.336 21.6 12.8 22.136 12.8 22.8C12.8 23.464 13.336 24 14 24H14.4Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInss);
export default __webpack_public_path__ + "static/media/inss.86e7a42b.svg";
export { ForwardRef as ReactComponent };